import axios from "axios";
import qs from "qs";

export const $axios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30e3
});

$axios.defaults.paramsSerializer = function (params) {
  return qs.stringify(params);
};

for (let method of ["request", "delete", "get", "head", "options", "post", "put", "patch"]) {
  $axios["$" + method] = function () {
    return this[method].apply(this, arguments).then(res => res && res.data);
  };
}
